"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COASTAL_COMMUNITY_BANK_ISAOA_ADDRESS = void 0;
exports.COASTAL_COMMUNITY_BANK_ISAOA_ADDRESS = {
    name: 'Coastal Community Bank ISAOA',
    line1: '548 Market St PMB #99555',
    line2: 'San Francisco, CA 94104-5401',
};
